import { useMemo } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";

import MaperOld from "../../pages/contacts/maperOld";

import styles from "./index.module.scss";

/** Карта всех магазинов (кейс «Россия») из стора contacts.allShops. */
export default function AllShopsMap({ isBaltex }) {
  const { allShops } = useSelector((state) => state.contacts);

  const mapPoints = useMemo(
    () => allShops.filter((shop) => shop.gpsLat && shop.gpsLon),
    [allShops],
  );

  return (
    <div className={clsx(styles.Adreses, isBaltex && styles.AdresesBaltex)}>
      <div className={styles.Map}>
        <MaperOld zoom={5} points={mapPoints} />
      </div>
    </div>
  );
}
